import { Injectable } from '@angular/core';
import {HttpClient} from '@angular/common/http';
import { Observable } from 'rxjs';
import { MessageService } from './message.service';
import { map } from 'rxjs/operators';
import { ConfigLoaderService } from '../config/configloader.service';
import { Issue } from '../models/issue';
import { Sticker } from '../models/sticker';


/**
 * this class represents access to all rest requests concerning Stickers data of the PyWall
 * this rest service honors isMock from settingservice and wont update data when isMock returns true
 */
@Injectable()
export class StickerService {

  private baseURL: string;

  constructor(
    private http: HttpClient,
    private messageService: MessageService,
    private configService: ConfigLoaderService,
  ) {
    this.baseURL = `${this.configService.getSettings().pyWallServer.url}`;
  }

  /**
   * Creates a new sticker either a new sticker template or a new attached sticker
   * If Sticker object has issue id set, it is an attached sticker,
   * otherwise it is a sticker template
   */
  addSticker(sticker: Sticker): Observable<Sticker> {
    const targetURL = this.baseURL + 'stickers/';
    return this.http.post<Sticker>(targetURL, sticker);
  }

  updateSticker(sticker: Sticker): void {
    const targetURL = this.baseURL + 'stickers/';
    this.http.put(targetURL, sticker).subscribe({
      error: (error) => {
        this.messageService.sendWarn(`Couldn't update Sticker ${sticker.id}, ${error}`);
      }
    });
  }

  removeSticker(sticker: Sticker): Observable<Sticker> {
    const targetURL = this.baseURL + `stickers/${sticker.id}/`;
    return this.http.delete<Sticker>(targetURL);
  }

  getStickersForIssue(issue: Issue): Observable<Sticker[]> {
    const targetURL = this.baseURL + `stickers/?issueId=${issue.id}/`;
    return this.http.get<Sticker[]>(targetURL).pipe(map(data => this.mapJSONToStickers(data)));
  }

  /**
   * Maps a given sticker json array to a Sticker object array
   *
   * @param data
   */
  public mapJSONToStickers(data: any): Sticker[] {
    const stickers = [];
    for (const s of data) {
      stickers.push(this.mapJSONToSticker(s));
    }
    return stickers;
  }

  /**
   * Maps a given sticker json to a Sticker object
   *
   * @param data
   */
  public mapJSONToSticker(data: any): Sticker {
    return new Sticker(
      data.id,
      data.issueId,
      data.projectKey,
      data.fileName,
      data.imageData,
      data.iconName,
      data.iconColor,
      data.comment,
      data.order,
      data.size
    );
  }
}
